import { useFormikContext } from "formik";
import { Input, Label } from "../../components/shared/InputField";
import { Box, Error, HStack, VStack } from "../../components/utils";
import { useShareCapitalDetails } from "../../queries/onBoarding";
import { HistoricalRoundModel } from "../../types/HistoricDataModel";

export default function ShareCapitalDetail() {
  const formik = useFormikContext<HistoricalRoundModel>();
  const { values, errors, touched, getFieldProps } = formik;
  const fieldTouched = touched?.companyCapitalDetails;
  const err = errors?.companyCapitalDetails;
  const authorizedTotal =
    (values.companyCapitalDetails?.equityAuthorizedShareCapital || 0) +
    (values.companyCapitalDetails?.preferenceAuthorizedShareCapital || 0);

  const paidUpTotal =
    (values.companyCapitalDetails?.equityPaidUpShareCapital || 0) +
    (values.companyCapitalDetails?.preferencePaidUpShareCapital || 0);

  return (
    <div className="w-full bg-white rounded-md mt-10">
      <Box className="px-10 text-lg text-left font-medium border-b py-4">
        <h6>Share Capital Setting</h6>
      </Box>
      <VStack className="w-full  px-10 py-4 gap-6">
        <VStack className="gap-2">
          <h6 className="text-lg">Authorised Capital</h6>
          <HStack className="gap-8">
            <div className="flex-1">
              <Label className="text-sm font-normal">
                Equity
                <span className="text-rose-400">*</span>
              </Label>
              <Input
                type="number"
                placeholder="Eg: 984839"
                className="w-120"
                {...getFieldProps(
                  "companyCapitalDetails.equityAuthorizedShareCapital"
                )}
              />
              {fieldTouched?.equityAuthorizedShareCapital &&
                err?.equityAuthorizedShareCapital && (
                  <Error text={err?.equityAuthorizedShareCapital} />
                )}
            </div>
            <div className="flex-1">
              <Label className="text-sm font-normal">
                Preference
                <span className="text-rose-400">*</span>
              </Label>
              <Input
                type="number"
                placeholder="Eg: 984839"
                className="w-120"
                {...getFieldProps(
                  "companyCapitalDetails.preferenceAuthorizedShareCapital"
                )}
              />
              {fieldTouched?.preferenceAuthorizedShareCapital &&
                err?.preferenceAuthorizedShareCapital && (
                  <Error text={err?.preferenceAuthorizedShareCapital} />
                )}
            </div>
            <div className="flex-1">
              <Label className="text-sm font-normal">
                Total
                <span className="text-rose-400">*</span>
              </Label>
              <Input
                readOnly
                type="number"
                placeholder="Eg: 984839"
                className="w-120"
                value={authorizedTotal}
              />
            </div>
          </HStack>
        </VStack>
        <VStack className="gap-2">
          <h6 className="text-lg">Paid Up Capital</h6>
          <HStack className="gap-8">
            <div className="flex-1">
              <Label className="text-sm font-normal">
                Equity
                <span className="text-rose-400">*</span>
              </Label>
              <Input
                type="number"
                placeholder="Eg: 984839"
                className="w-120"
                {...getFieldProps(
                  "companyCapitalDetails.equityPaidUpShareCapital"
                )}
              />
              {fieldTouched?.equityAuthorizedShareCapital &&
                err?.equityAuthorizedShareCapital && (
                  <Error text={err?.equityAuthorizedShareCapital} />
                )}
            </div>
            <div className="flex-1">
              <Label className="text-sm font-normal">
                Preference
                <span className="text-rose-400">*</span>
              </Label>
              <Input
                type="number"
                placeholder="Eg: 984839"
                className="w-120"
                {...getFieldProps(
                  "companyCapitalDetails.preferencePaidUpShareCapital"
                )}
              />
              {fieldTouched?.preferencePaidUpShareCapital &&
                err?.preferencePaidUpShareCapital && (
                  <Error text={err?.preferencePaidUpShareCapital} />
                )}
            </div>

            <div className="flex-1">
              <Label className="text-sm font-normal">
                Total
                <span className="text-rose-400">*</span>
              </Label>
              <Input
                readOnly
                type="number"
                placeholder="Eg: 984839"
                className="w-72"
                value={paidUpTotal}
              />
            </div>
          </HStack>
        </VStack>
      </VStack>
    </div>
  );
}
